import style from "./Article.module.scss";

type VideoProps = {
  youtube: string;
};

const processYoutubeLink = (src: string) => {
  //https://youtu.be/B0N01cbPEKE
  const id = src.split("/").reverse()[0];
  return `https://www.youtube.com/embed/${id}?controls=0`;
};

export const  Video = ({ youtube }: VideoProps) => {
   return  <iframe
    className={style.iFrame}
    src={processYoutubeLink(youtube)}
    title="YouTube video player"
    frameBorder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowFullScreen
  />
}
